import React, { useState } from "react";
import { ServicePage } from "@/components/ServicePage";
import { WlanExplainers } from "@/components/explainers/WlanExplainers";

const VARIANTS = {
  basic: {
    title: "Managed WLAN Basic",
    subtitle: "Stabiles, sicheres WLAN für Unternehmen – ohne sich um Konfiguration, Wartung oder Updates kümmern zu müssen.",
    features: [
      { title: "Zentrales Dashboard", desc: "Intuitive Netzwerkverwaltung mit Echtzeit-Metriken." },
      { title: "Sicherheitsfeatures", desc: "Fortschrittliche Sicherheitsprotokolle schützen Ihr Netzwerk." },
      { title: "Skalierbare Architektur", desc: "Wächst flexibel mit den Anforderungen Ihres Unternehmens." },
      { title: "Effiziente Überwachung", desc: "Live-Daten zu Nutzerzahlen, Signalstärke und Bandbreitennutzung." },
      { title: "Einfache Integration", desc: "Kompatibel mit bestehenden Systemen für nahtlosen Übergang." },
      { title: "Basic Support", desc: "Per E-Mail oder Hotline – schnelle Hilfe durch unser IT-Team." },
    ],
  },
  silber: {
    title: "Managed WLAN Silber",
    subtitle: "Alle Vorteile aus Basic – plus erweiterter Support, Vor-Ort-Service und SLA mit garantierter Reaktionszeit.",
    features: [
      { title: "Erweiterter Support", desc: "Telefonischer Support inklusive – auch außerhalb der Geschäftszeiten." },
      { title: "Vor-Ort-Service", desc: "Technikerbesuch bei Bedarf – fest eingeplant im Paket." },
      { title: "SLA garantiert", desc: "Reaktionszeiten vertraglich zugesichert." },
      { title: "Erweitertes Monitoring", desc: "Proaktive Benachrichtigungen bei Anomalien." },
      { title: "Quartalsreviews", desc: "Regelmäßige Auswertungen und Optimierung." },
      { title: "Inkl. Supportkosten", desc: "Keine versteckten Stundenpauschalen – alles inklusive." },
    ],
  },
  plus: {
    title: "Managed WLAN Plus – Unser Glücklichpaket",
    subtitle: "Rundum-sorglos: Hardware, Konfiguration, Wartung, Support – plus Erweiterungen wie Gast-WLAN und VLAN-Trennung.",
    features: [
      { title: "Komplette Hardware", desc: "Access Points und Controller inklusive – Miete statt Kauf." },
      { title: "Gast-WLAN", desc: "Sicheres, getrenntes Netzwerk für Besucher mit Login-Portal." },
      { title: "VLAN-Trennung", desc: "Mitarbeiter, Gäste, IoT-Geräte sauber getrennt." },
      { title: "Höchste Sicherheit", desc: "WPA3, Captive Portal, automatische Firmware-Updates." },
      { title: "Voller 24/7 Support", desc: "Immer erreichbar – per Hotline, E-Mail und Vor-Ort." },
      { title: "Kostenfreie Erweiterung", desc: "Mit Ihrem Unternehmen wächst auch Ihr WLAN-Setup." },
    ],
  },
};

export const ManagedWlan = () => {
  const [variant, setVariant] = useState("basic");
  const data = VARIANTS[variant];
  return (
    <div data-testid="page-managed-wlan">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 pt-12">
        <div className="inline-flex border border-line bg-white shadow-soft">
          {Object.keys(VARIANTS).map((k) => (
            <button
              key={k}
              data-testid={`wlan-variant-${k}`}
              onClick={() => setVariant(k)}
              className={`px-6 py-3 font-mono text-xs uppercase tracking-[0.2em] transition-colors ${
                variant === k ? "bg-primary text-white" : "text-muted hover:text-primary"
              }`}
            >
              {k}
            </button>
          ))}
        </div>
      </div>
      <ServicePage
        slotAfterFeatures={<WlanExplainers />}
        testIdSlug={`wlan-${variant}`}
        seo={{
          title: `Managed WLAN ${variant.charAt(0).toUpperCase() + variant.slice(1)} · Firmen-WLAN`,
          description: "Managed WLAN für Unternehmen: stabiles, sicheres Firmen-WLAN mit zentralem Controller, Online-Dashboard und Support. Basic, Silber oder Plus.",
          keywords: "Managed WLAN, Firmen WLAN, Business WiFi, WLAN Controller, Access Points, Hotspot, Gast-WLAN, WLAN Hessen",
          serviceName: "Managed WLAN",
          breadcrumb: [
            { name: "Start", path: "/" },
            { name: "Managed WLAN", path: "/managed-wlan" },
          ],
        }}
        eyebrow={`Managed WLAN · ${variant.toUpperCase()}`}
        title={data.title}
        subtitle={data.subtitle}
        heroImage={variant === "basic" ? "/wp-images/wlan-basic.jpg" : variant === "plus" ? "/wp-images/wlan-plus.jpg" : "/wp-images/wlan-basic.jpg"}
        features={data.features}
        testimonials={[
          { quote: "Das Team von IT-Servicepoint hat meine Erwartungen übertroffen und ein stabiles, sicheres WLAN eingerichtet.", name: "Laura M.", role: "IT-Managerin" },
          { quote: "Die Effizienz des Teams hat unser Netzwerkmanagement deutlich verbessert.", name: "Michael R.", role: "Geschäftsinhaber" },
          { quote: "Mit dem Managed WLAN haben wir endlich eine zuverlässige Lösung für unser Unternehmensnetzwerk.", name: "Sabine K.", role: "Projektleiterin" },
        ]}
      />
    </div>
  );
};
